export default {
  name: 'CrmDetailsInfo',
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    percentual () {
      let result = 0
      if (this.card && this.card.boardColumn) {
        result = this.card.boardColumn.percentual
      }
      return result
    },
    boardColumnName () {
      let result = ''
      if (this.card && this.card.boardColumn) {
        result = this.card.boardColumn.nome
      }
      return result
    },
    color () {
      let result = ''
      if (this.card && this.card.boardColumn) {
        result = 'border-left: solid ' + this.card.boardColumn.cor
      }
      return result
    },
    countDaysBetweenDateOfCreation () {
      if (this.card && this.card.dataCriacao) {
        let dataInicio = Math.floor(new Date(this.card.dataCriacao) / 8.64e7)
        let dataFim = Math.floor(new Date() / 8.64e7)
        let diffDays = dataFim - dataInicio
        return diffDays
      }
      return 0
    },
    formatDateDay () {
      const date = new Date(this.card.dataCriacao)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()

      return `${day}/${month}/${year}`
    },
    formatDateHour () {
      const date = new Date(this.card.dataCriacao)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `às ${hours}:${minutes}`
    },
    countContatos () {
      if (this.card && this.card.cardDetails && this.card.cardDetails.countContatos) {
        return this.card.cardDetails.countContatos
      }
      return 0
    },
    countAgendamentos () {
      if (this.card && this.card.cardDetails && this.card.cardDetails.countAgendamentos) {
        return this.card.cardDetails.countAgendamentos
      }
      return 0
    },
    numberProtocol () {
      let numberProtocol = ''
      if (this.card && this.card.protocolo) {
        numberProtocol = this.card.protocolo
      }
      return numberProtocol
    },
    createdBy () {
      let createdBy = ''
      if (this.card && this.card.usuarioCriador) {
        createdBy = this.card.usuarioCriador.nome
      } else {
        createdBy = 'SEM INFORMAÇÃO'
      }
      return createdBy
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/info/info.js